/* eslint-disable consistent-return */
// import { uniq } from "lodash";
import { atom, selector, selectorFamily } from "recoil";

import { GetEvaluationFormByFilterDocument } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { EvaluationFormInterface, FormSectionInterface } from "src/types/evaluationForm.d";

// import { activeProductsState } from ".";
import keys from "./constants";
import { routerChangeState } from "./generalState";

// import { pendingBookingOrdersState } from "./orderByCondition";

export const currentEvaluationIdState = atom<string>({
  key: keys.CURRENT_EVALUATION_ID,
  default: ""
});

export const currentSectionIndexState = atom<number>({
  key: keys.CURRENT_SECTION_INDEX,
  default: 0
});

export const currentSectionState = selector<FormSectionInterface>({
  key: keys.CURRENT_SECTION,
  get: ({ get }) => get(formSectionsState)[get(currentSectionIndexState)]
});

export const sectionVisitsState = atom<number[]>({
  key: keys.SECTION_VISITS,
  default: []
});

export const evaluationState = selector<EvaluationFormInterface>({
  key: keys.EVALUATION,
  get: async ({ get }) => {
    get(routerChangeState);

    const currentEvaluationId = get(currentEvaluationIdState);

    if (!currentEvaluationId) return null;
    const evalData = await graphQLClient.request(GetEvaluationFormByFilterDocument, {
      input: {
        id: currentEvaluationId
      }
    });

    const evaluation = evalData.getEvaluationFormByFilter;
    if (evaluation.length === 0) return null;
    return evaluation[0];
  }
});

export const formSectionsState = selector<FormSectionInterface[]>({
  key: keys.FORM_SECTIONS_STATE,
  get: async ({ get }) => {
    const evaluation = get(evaluationState);

    return evaluation?.formSections?.filter(
      (d) =>
        d.sectionType === "question" ||
        d.sectionType === "info" ||
        d.sectionType === "formcompleted" ||
        d.sectionType === "pregnancyInfo" ||
        d.sectionType === "pregnancyCreateChecklist"
    );
  }
});

export const evaluationStepperState = atom<
  "intro" | "goalsIntro" | "goals" | "preQA" | "evaluation" | "checkout" | "save"
>({
  key: keys.EVALUATION_STEPPER_STATE,
  default: "intro"
});

export const totalSectionsState = selector<number>({
  key: keys.TOTAL_SECTIONS_STATE,
  get: ({ get }) => get(formSectionsState).length - 1
});

export const evalTotalSectionsState = selector<number>({
  key: keys.EVALS_TOTAL_SECTIONS_STATE,
  get: ({ get }) => {
    const evaluation = get(evaluationState);

    if (evaluation.total) {
      return evaluation.total;
    }

    return get(formSectionsState).length - 1;
  }
});

export const currentJumpToTreeState = atom({
  key: keys.CURRENT_JUMP_TO_TREE_STATE,
  default: []
});

export const reloadCompletedEvaluationState = atom({
  key: keys.RELOAD_COMPLETED_EVALUATION_STATE,
  default: 0
});

export const goalsState = atom({
  key: "goals_state",
  default: null
});

export const evaluationByIdState = selectorFamily<EvaluationFormInterface, string>({
  key: "EVALUATION_BY_ID_STATE",
  get:
    (id: string) =>
    async ({ get }) => {
      get(reloadCompletedEvaluationState);
      get(routerChangeState);

      const evalData = await graphQLClient.request(GetEvaluationFormByFilterDocument, {
        input: {
          id
        }
      });

      const evaluation = evalData.getEvaluationFormByFilter;

      if (evaluation.length === 0) return;

      return { ...evaluation[0], id };
    }
});

export const completedEvaluationIdState = atom<string>({
  key: keys.COMPLETED_EVALUATION_ID_STATE,
  default: ""
});
